import { coreDefaultTheme } from '@kite-js/theme';
import { FontWeightTheme } from '@kite-js/theme-types';

const weights: FontWeightTheme = {
    ...coreDefaultTheme.font.weights,
    Light: '200',
    Normal: '400',
    Strong: '700',
};

export default weights;
